export default "__VITE_ASSET__CqKsrn8A__"